/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createElement } from "react";

import { usePlayerComponents } from "../../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import {
  usePlayerController,
  usePlayerSettings,
} from "../../../../../BasePlayer";

import "./ChromecastButton.scss";

export const ChromecastButton = () => {
  const { player } = usePlayerController();
  const {
    ui: { tooltipOffset },
  } = usePlayerSettings();
  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();

  const isCastAvailable = player.castSender?.isAvailable();
  const isCasting = player.castSender?.isConnected();
  const tooltip = isCasting
    ? t("PLAYER_TOOLTIP_CHROMECAST_DISCONNECT")
    : t("PLAYER_TOOLTIP_CHROMECAST_CONNECT");

  if (!isCastAvailable) {
    return null;
  }

  return (
    <Button
      variant={isCasting ? "primary" : "secondary"}
      className="ChromecastButton"
      tooltip={tooltip}
      tooltipOffset={tooltipOffset}
      aria-label={tooltip}
      iconOnly
    >
      {createElement("google-cast-launcher")}
    </Button>
  );
};
